import { queryOptions } from '@tanstack/react-query';

import { useLocalizationStore } from '$/components/core/Localization/hooks/useLocalizationStore';
import { STANDARD_STALE_TIME } from '$/services/constants';
import {
  getAllInspirations,
  getInspirationById,
} from '$/services/usecases/inspirations';

export const allInspirationsQuery = (includeCredentials = true) => {
  const { country } = useLocalizationStore.getState();

  return queryOptions({
    queryKey: ['inspirations', country, includeCredentials],
    queryFn: ({ signal }) =>
      getAllInspirations(signal, country, includeCredentials),
    staleTime: STANDARD_STALE_TIME,
  });
};

export const inspirationQuery = (
  id: string,
  ignoreMissingMaterials = false,
  includeCredentials = true,
) =>
  queryOptions({
    queryKey: ['inspiration', id, ignoreMissingMaterials, includeCredentials],
    queryFn: ({ signal }) =>
      getInspirationById(
        id,
        signal,
        ignoreMissingMaterials,
        includeCredentials,
      ),
    staleTime: STANDARD_STALE_TIME,
  });
